<div *ngIf="pageLoading1" class="loader text-center">
	<img src="../../assets/img/loading.gif" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if ((!uId && navbar.user?.tms_access?.create_news) || (uId && navbar.user?.tms_access?.edit_news)) {
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('news')}" id="news"
					formControlName="news" placeholder=""></textarea>
				<label for="news">News Text*</label>
			</div>
			<p *ngIf="showError('news')" class="text-danger">
				<span *ngIf="f.news.errors?.required">
					Required
				</span>
				<span *ngIf="f.news.errors?.incorrect">
					{{customError.news}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('link')}" id="link"
					formControlName="link" placeholder=""></textarea>
				<label for="link">Link</label>
			</div>
			<p *ngIf="showError('link')" class="text-danger">
				<span *ngIf="f.link.errors?.required">
					Required
				</span>
				<span *ngIf="f.link.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.link.errors?.incorrect">
					{{customError.link}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<div class="input-group">
				<div class="form-floating">
					<input class="form-control" [ngClass]="{'is-invalid':showError('start_date')}" placeholder=""
						formControlName="start_date" ngbDatepicker id="start_date" #start_date="ngbDatepicker"
						[minDate]="minDate" [container]="'body'" />
					<label for="start_date">Start Date*</label>
				</div>
				<button class="btn btn-outline-secondary" (click)="start_date.toggle()" type="button">
					<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
				</button>
			</div>
			<p *ngIf="showError('start_date')" class="text-danger">
				<span *ngIf="f.start_date.errors?.required">
					Required
				</span>
				<span *ngIf="f.start_date.errors?.ngbDate">
					Invalid
				</span>
				<span *ngIf="f.start_date.errors?.incorrect">
					{{customError.start_date}}
				</span>
			</p>
		</div>
		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<div class="input-group">
				<div class="form-floating">
					<input class="form-control" [ngClass]="{'is-invalid':showError('end_date')}" placeholder=""
						formControlName="end_date" ngbDatepicker id="end_date" #end_date="ngbDatepicker"
						[minDate]="minDate" [container]="'body'" />
					<label for="end_date">End Date*</label>
				</div>
				<button class="btn btn-outline-secondary" (click)="end_date.toggle()" type="button">
					<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
				</button>
			</div>
			<p *ngIf="showError('end_date')" class="text-danger">
				<span *ngIf="f.end_date.errors?.required">
					Required
				</span>
				<span *ngIf="f.end_date.errors?.ngbDate">
					Invalid
				</span>
				<span *ngIf="f.end_date.errors?.incorrect">
					{{customError.end_date}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}